import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=096b97eb&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096b97eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('096b97eb')) {
      api.createRecord('096b97eb', component.options)
    } else {
      api.reload('096b97eb', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=096b97eb&scoped=true&", function () {
      api.rerender('096b97eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wFs8uwBo9sHJ/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports